// === FILE: controllers/clipboard_controller.ts ===
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "icon"]

  declare readonly linkTarget: HTMLAnchorElement
  declare readonly iconTarget: HTMLElement

  private originalIcon = ""

  connect() {
    // Sauvegarder l'icône originale
    this.originalIcon = this.iconTarget.innerHTML
  }

  async copy() {
    try {
      // Construire l'URL complète
      const slug = this.linkTarget.textContent?.trim() || ""
      const fullUrl = `${window.location.origin}/${slug}`

      // Copier dans le presse-papiers
      await navigator.clipboard.writeText(fullUrl)

      // Sauvegarder le contenu original du bouton (SVG)
      if (!this.originalIcon) {
        this.originalIcon = this.iconTarget.innerHTML
      }

      // Feedback visuel : changer l'icône en checkmark
      this.iconTarget.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      `

      // Ajouter une classe pour l'animation et le style
      this.iconTarget.classList.add("copied")

      // Réinitialiser après 2 secondes
      setTimeout(() => {
        this.iconTarget.innerHTML = this.originalIcon
        this.iconTarget.classList.remove("copied")
      }, 2000)

    } catch (err) {
      console.error("Erreur lors de la copie:", err)

      // Fallback : sélectionner le texte
      this.fallbackCopy()
    }
  }

  // Méthode de secours pour les anciens navigateurs
  private fallbackCopy() {
    const range = document.createRange()
    range.selectNode(this.linkTarget)
    window.getSelection()?.removeAllRanges()
    window.getSelection()?.addRange(range)

    try {
      document.execCommand("copy")
      window.getSelection()?.removeAllRanges()

      // Même feedback visuel
      this.iconTarget.classList.add("copied")
      setTimeout(() => {
        this.iconTarget.classList.remove("copied")
      }, 2000)
    } catch (err) {
      console.error("Fallback copy failed:", err)
    }
  }
}
